import { ChartTooltips } from 'chart.js';
import { List } from 'immutable';
import { NavigationService } from '../../navigation/navigation.service';
import { Dataset } from '../sub-models/dataset.model';
import { Tooltip } from '../sub-models/tooltip.model';

export abstract class ChartBuilder {
  constructor(protected navigationService: NavigationService) {}

  /**
   * @param datasetOffsetUnshift is used if there is any dataset without tooltips.
   */
  buildTooltips(
    datasets: List<Dataset>,
    datasetOffsetUnshift: number = 0
  ): ChartTooltips {
    return {
      displayColors: false,
      filter: (tooltipItem, data) => {
        const dataset: Dataset = datasets.get(
          tooltipItem.datasetIndex - datasetOffsetUnshift
        );
        const tooltip: Tooltip = dataset.tooltips.get(tooltipItem.index);

        return !!tooltip;
      },
      callbacks: {
        title: (tooltipItems, data) => {
          if (tooltipItems && tooltipItems[0]) {
            const dataset: Dataset = datasets.get(
              tooltipItems[0].datasetIndex - datasetOffsetUnshift
            );
            const tooltip: Tooltip = dataset.tooltips.get(
              tooltipItems[0].index
            );

            return tooltip ? tooltip.label : null;
          }

          return null;
        },
        label: (tooltipItem, data) => {
          const dataset: Dataset = datasets.get(
            tooltipItem.datasetIndex - datasetOffsetUnshift
          );
          const tooltip: Tooltip = dataset.tooltips.get(tooltipItem.index);

          return tooltip ? tooltip.summaries.toArray() : null;
        },
      },
    };
  }

  /**
   * @param datasetOffsetUnshift is used if there is any dataset without clickable elements.
   * @param trackChartClick callback to parent for tracking chart click
   */
  handleClick(
    datasets: List<Dataset>,
    datasetOffsetUnshift: number = 0,
    trackChartClick?: (deeplinkUrl: string) => void
  ) {
    return (event, elements) => {
      if (elements && elements[0]) {
        const bar = elements[0];
        const dataset: Dataset = datasets.get(
          bar._datasetIndex - datasetOffsetUnshift
        );
        const url: string = dataset.urls.get(bar._index);

        if (url) {
          this.navigationService.goToDeepLink(url);

          if (trackChartClick) {
            trackChartClick(url);
          }
        }
      }
    };
  }
}
